<template>
    <div class="d-inline">
        <button type="button" class="btn btn-sm shadow-sm btn-outline-secondary" data-toggle="modal"
                data-target="#share-modal">
            {{ buttonText }}
        </button>
        <div class="modal fade" id="share-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ title }}
                        </h5>
                        <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <button type="button" class="btn btn-sm btn-outline-secondary shadow-sm" @click="all">
                                Alle
                            </button>
                            <button type="button" class="btn btn-sm btn-outline-secondary shadow-sm" @click="none">
                                Niemand
                            </button>
                        </div>

                        <div class="form-check" v-for="(permission, index) in permissions">
                            <input class="form-check-input"
                                   type="checkbox"
                                   :value="permission.user_id"
                                   :id="'permission-' + permission.user_id"
                                   v-model="permission.authorized"
                                   @change="updatePermission(index)">
                            <label class="form-check-label" :for="'permission-' + permission.user_id">
                                {{ permission.user_name }}
                            </label>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" type="button" data-dismiss="modal">Schließen</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        token: {
            type: String,
            required: true
        },
        permissionsUrl: {
            type: String,
            required: true
        },
        buttonText: {
            type: String,
            default: 'Teilen'
        },
        title: {
            type: String,
            default: 'Zugriff verwalten'
        }
    },
    data() {
        return {
            permissions: []
        };
    },
    mounted() {
        axios.get(this.permissionsUrl).then((res) => {
            this.permissions = res.data;
        });
    },
    methods: {
        updatePermission(index) {
            // wait for model change
            this.$nextTick(() => {
                const permission = this.permissions[index];
                axios.post(this.permissionsUrl, {
                    _token: this.token,
                    user_id: permission.user_id,
                    authorized: permission.authorized,
                }).catch(() => {
                    alert("Fehler");
                });
            });
        },
        all() {
            for (let i = 0; i < this.permissions.length; i++) {
                if (!this.permissions[i].authorized) {
                    this.permissions[i].authorized = true;
                    this.updatePermission(i);
                }
            }
        },
        none() {
            for (let i = 0; i < this.permissions.length; i++) {
                if (this.permissions[i].authorized) {
                    this.permissions[i].authorized = false;
                    this.updatePermission(i);
                }
            }
        },
    },
}
</script>

<style scoped>

</style>
